export default __webpack_public_path__ + "eb1890b78a0b07779da70ce2274f0c80.png";